module.exports = "/* Header */\n.home-slider {\n  height: 100vh; }\n.home-slider .slide {\n    background-size: cover;\n    background-position: center; }\nswiper > .swiper.s-wrapper {\n  width: 100%;\n  height: 100vh !important; }\n/*=====================================================\r\n=            reveal on scroll w fullpagejs            =\r\n=====================================================*/\n/*=====  End of reveal on scroll w fullpagejs  ======*/\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.scss
// module id = ./src/app/home/home.component.scss
// module chunks = main